"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _once2 = _interopRequireDefault(require("lodash/once"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _WorkflowConsumer = _interopRequireDefault(require("./WorkflowConsumer"));

var _WorkflowStepListImpl = _interopRequireDefault(require("./WorkflowStepListImpl"));

var _excluded = ["children"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint react/no-unused-state: 0 */

/* eslint react/sort-comp: 0 */
var WorkflowStepList = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(WorkflowStepList, _React$Component);

  var _super = _createSuper(WorkflowStepList);

  function WorkflowStepList() {
    var _this;

    (0, _classCallCheck2.default)(this, WorkflowStepList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "stepListImplRef", /*#__PURE__*/_react.default.createRef());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "doRegister", function (registrationFn) {
      registrationFn(_this.stepListImplRef);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "doRegisterOnce", (0, _once2.default)(_this.doRegister));
    return _this;
  }

  (0, _createClass2.default)(WorkflowStepList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          propsForwarded = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      return /*#__PURE__*/(0, _jsx2.default)(_WorkflowConsumer.default, {}, void 0, function (_ref) {
        var registerStepListImplRef = _ref.registerStepListImplRef,
            stepListImplRef = _ref.stepListImplRef,
            workflowDidMount = _ref.workflowDidMount;

        _this2.doRegisterOnce(registerStepListImplRef);

        if (stepListImplRef && workflowDidMount) {
          return /*#__PURE__*/_react.default.createElement(_WorkflowStepListImpl.default, (0, _extends2.default)({
            ref: _this2.stepListImplRef
          }, propsForwarded), children);
        }

        return null;
      });
    }
  }]);
  return WorkflowStepList;
}(_react.default.Component);

WorkflowStepList.defaultProps = {
  containerId: 'workflow-step-list-container'
};
WorkflowStepList.displayName = 'WorkflowV2.StepList';
var _default = WorkflowStepList;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/workflow/impl/WorkflowStepList.js
// module id = 4507
// module chunks = 25